
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dicas",
      function () {
        return require("private-next-pages/dicas/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dicas"])
      });
    }
  